/**
 * Per-store admin settings that gate the Cart V2 / discount gamification beta
 * (storeSettings.enableDiscountGamification, storeSettings.enableCartInterstitial).
 *
 * These are now the *only* gate for growth.ecomm.cart-v2.rollout,
 * consumer.ecomm.gamification.rollout, and consumer.ecomm.cart-interstitial.rollout in app code --
 * the LaunchDarkly flags themselves are no longer read here or at any of this module's call
 * sites, so there is currently no LaunchDarkly-side kill switch for this rollout. The
 * flags/segment remain configured in LaunchDarkly for now (unused), pending a follow-up cleanup
 * once these settings are verified in production.
 *
 * Pure helper functions, not React hooks -- there's nothing here that needs to be a hook, and
 * packages/common must not import app-context hooks like useDispensary() (see README.md), so
 * these take the dispensary object as a plain argument instead.
 */

type DiscountGamificationStoreSettings =
  | {
      enableDiscountGamification?: boolean | null;
      enableCartInterstitial?: boolean | null;
    }
  | null
  | undefined;

type DispensaryWithStoreSettings =
  | {
      storeSettings?: DiscountGamificationStoreSettings;
    }
  | null
  | undefined;

/**
 * storeSettings.enableDiscountGamification (super admin only). Gates both the Cart V2 dropdown
 * experience and discount gamification (tiered discount progress/badges) for this store.
 */
export function isDiscountGamificationEnabled(dispensary: DispensaryWithStoreSettings): boolean {
  return Boolean(dispensary?.storeSettings?.enableDiscountGamification);
}

/**
 * storeSettings.enableCartInterstitial (consumer/store-admin facing). Only has effect while
 * enableDiscountGamification is also enabled for the store, mirroring the LaunchDarkly
 * prerequisite consumer.ecomm.cart-interstitial.rollout previously had on
 * growth.ecomm.cart-v2.rollout.
 */
export function isCartInterstitialEnabled(dispensary: DispensaryWithStoreSettings): boolean {
  const storeSettings = dispensary?.storeSettings;
  return Boolean(storeSettings?.enableDiscountGamification && storeSettings.enableCartInterstitial);
}
